module.exports = __webpack_public_path__ + "img/line1.81a478d0.png";